// Styles for __name__ go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledTab = styled.div`
  border-radius: ${toRem(12)};
  box-shadow: 0 ${toRem(3)} ${toRem(16)} 0 rgba(0, 0, 0, 0.15);
  padding: ${toRem(32)} ${toRem(0)} ${toRem(27)} ${toRem(0)};
  .m-standard-tab-list {
    border-bottom: 1.6px solid ${baseVariables.color.neutral30} !important;
  }
  .m-standard-tab-list-item:first-child {
    margin-right: ${toRem(17)};
  }
  @media ${baseVariables.mediaQuery.md} {
    padding: ${toRem(24)} ${toRem(0)} ${toRem(27)} ${toRem(0)};
  }
  @media ${baseVariables.mediaQuery.lg} {
    padding: ${toRem(32)} ${toRem(0)} ${toRem(27)} ${toRem(0)};
  }
  .tab-desc {
    margin-top: ${toRem(-5)};
  }

  .tabUL {
    justify-content: space-evenly;
    @media ${baseVariables.mediaQuery.lg} {
      width: 100% !important;
    }
  }

  .tabLi-show-all {
    width: 100% !important;
  }
  .inactive-tab {
    .tabIconText,
    .t-subtitle-m {
      color: ${baseVariables.color.neutral40};
    }
  }

  .tabIconText {
    .iconContainer {
      font-size: ${toRem(24)};
      text-align: center;
      margin-bottom: 0.5rem;
      font-size: ${toRem(24)};
    }
    span {
      text-align: center;
      font-size: ${toRem(13)};
      font-weight: 500;
    }
    display: grid;
    margin-top: 0.5rem;
    margin-bottom: 0.2rem;
    margin-left: 0;
    margin-right: 0;
  }

  .glide {
    @media ${baseVariables.mediaQuery.md} {
      ul {
        li {
          width: inherit !important;
        }
      }
    }
    &__track {
      padding-top: ${toRem(24)};
      .glide__slides_authoring {
        @media ${baseVariables.mediaQuery.md} {
          flex-wrap: nowrap;
        }
        width: 100% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        .aem-container {
          padding: 0;
        }
      }
    }
    &__track__pt3 {
      overflow: hidden;
      padding-top: ${toRem(8)};
      .glide__slides_authoring {
        width: 100% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        .aem-container {
          padding: 0;
        }
      }
    }
    .center-align {
      display: flex;
      justify-content: center;
      align-items: center;
      .carouselControlType1.stand-arrow {
        .left-arrow {
          box-shadow: none;
          border-radius: 0px;
          margin-top: 2rem;
          background: linear-gradient(
            var(--arrow-direction),
            #fff 0%,
            #fff 5%,
            rgba(255, 255, 255, 0.64) 60%,
            rgba(255, 255, 255, 0) 100%,
            rgba(255, 255, 255, 0) 100%
          );
          color: rgb(28, 28, 28);
          top: 0px;
        }
        .right-arrow {
          box-shadow: none;
          border-radius: 0px;
          margin-top: 2rem;
          background: linear-gradient(
            var(--arrow-direction),
            #fff 0%,
            #fff 5%,
            rgba(255, 255, 255, 0.64) 60%,
            rgba(255, 255, 255, 0) 100%,
            rgba(255, 255, 255, 0) 100%
          );
          color: rgb(28, 28, 28);
          top: 0px;
        }
      }
    }
  }
`;
